module.exports = ""


//////////////////
// WEBPACK FOOTER
// D:/FMFB/FMFB Dashboard/src/app/auth/logout/logout.component.html
// module id = ../../../../../src/app/auth/logout/logout.component.html
// module chunks = main